import { Link } from 'react-router-dom';
import { relatedPages } from '@/mocks/corporateData';
import { useTranslation } from 'react-i18next';

export default function RelatedPages() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('corporate.related.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporate.related.title')}
          </h2>
          {String(t('corporate.related.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {relatedPages.map((page, idx) => (
            page.comingSoon ? (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/60 p-5 opacity-70"
              >
                <h3 className="font-heading text-[16px] text-foreground-700 tracking-[0.05em] mb-2">
                  {t(`corporate.related.page${idx + 1}.title`)}
                </h3>
                <p className="text-[14px] text-foreground-400 tracking-[0.03em] leading-relaxed mb-3">
                  {t(`corporate.related.page${idx + 1}.desc`)}
                </p>
                <div className="flex items-center gap-2 text-foreground-400">
                  <span className="text-[13px] tracking-[0.06em]">{t(`corporate.related.page${idx + 1}.desc`)}</span>
                </div>
              </div>
            ) : (
              <Link
                key={idx}
                to={page.href}
                className="card-glow group block bg-background-50 border border-background-200/60 p-5 cursor-pointer"
              >
                <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                  {t(`corporate.related.page${idx + 1}.title`)}
                </h3>
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">
                  {t(`corporate.related.page${idx + 1}.desc`)}
                </p>
                <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                  <span className="text-[13px] tracking-[0.06em]">{t('corporate.related.viewDetail')}</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </Link>
            )
          ))}
        </div>

        {/* Bottom text link to personal courses */}
        <div className="text-center mt-12 pt-10 border-t border-background-200/60">
          <Link
            to="/courses"
            className="text-[15px] text-foreground-400 hover:text-accent-500 tracking-[0.05em] transition-colors"
          >
            {t('corporate.related.coursesLink')}
          </Link>
        </div>
      </div>
    </section>
  );
}
